import React from "react";
import { Navigate, Route } from "react-router-dom";
import { RouteGuard } from "../../../components/route-guard";
import AttendancePage from "../../../features/attendance/AttendancePage";
import CampaignPage from "../../../features/campaign";
import CreateCampaignPage from "../../../features/campaign/page/CreateCampaignPage";
import UpdateCampaignPage from "../../../features/campaign/page/UpdateCampaignPage";
import UpdateProgramPage from "../../../features/campaign/page/UpdateProgramPage";
import { DashboardPage } from "../../../features/dashboard";
import DevPlaygroundPage from "../../../features/dev-playground/DevPlaygroundPage";
import EGiftCardPage from "../../../features/e-gift-card/pages/EGiftCardPage";
import CreateEGiftCardPage from "../../../features/e-gift-card/pages/CreateEGiftCardPage";
import UpdateEGiftCardPage from "../../../features/e-gift-card/pages/UpdateEGiftCardPage";
import {
  EventCreatePage,
  EventDetailsPage,
  EventListPage,
  EventUpdatePage,
} from "../../../features/event/pages";
import HeatMapPage from "../../../features/heat-map/pages/HeatMapPage";
import HeatMapPdfReport from "../../../features/heat-map/pages/HeatMapPdfReport";
import BusinessProfilePage from "../../../features/MERCHANT/merchant-business-profile/BusinessProfilePage";
import { MerchantCouponListPage } from "../../../features/MERCHANT/coupon";
import MerchantHeatmapPage from "../../../features/MERCHANT/merchant-heatmap/MerchantHeatmapPage";
import MerchantHeatmapPdfReport from "../../../features/MERCHANT/merchant-heatmap/MerchantHeatmapPdfReport";
import CreateNewsPage from "../../../features/news/page/CreateNewsPage";
import NewListPage from "../../../features/news/page/NewListPage";
import UpdateNewsPage from "../../../features/news/page/UpdateNewsPage";
import ViewNewsArticlePage from "../../../features/news/page/ViewNewsArticlePage";
import {
  CreateNotificationPage,
  EditNotificationPage,
  NotificationPage,
} from "../../../features/notification";
import ProfilePage from "../../../features/profile/pages/ProfilePage";
import OutboxNotificationsPage from "../../../features/outbox-notifications/pages/OutboxNotificationsPage";
import QRScannerTutorial from "../../../features/qr-scanner/pages/QRScannerTutorial";
import { RecentActivityPage } from "../../../features/recent-activity";
import RewardHistoryPage from "../../../features/reward-history/RewardHistoryPage";
import { ReportsPresentationSample } from "../../../features/reports/components/ReportsPresentationSample";
import ResidentReportPage from "../../../features/reports/resident/pages/ResidentReportPage";
import NriImpactReportPage from "../../../features/reports/nri-impact/pages/NriImpactReportPage";
import ProgramPerformanceReportPage from "../../../features/reports/program-performance/pages/ProgramPerformanceReportPage";
import NeighborhoodReachReportPage from "../../../features/reports/neighborhood-reach/pages/NeighborhoodReachReportPage";
import { RuntimeConfigurationPage } from "../../../features/runtime-configuration";
import { WalletTransactionsPage } from "../../../features/wallet-transactions";
import { SyncPointsPage } from "../../../features/sync-points";
import { CategoriesPage } from "../../../features/categories";
import { MerchantBrandCatalogPage } from "../../../features/merchant-brands";
import { MerchantCategoriesPage } from "../../../features/merchant-categories";
import { MissingRewardsPage } from "../../../features/sync-points";
import { OrganizationsPage } from "../../../features/organizations";
import CreateSurveyPage from "../../../features/survey/pages/CreateSurveyPage";
import EditSurveyPage from "../../../features/survey/pages/EditSurveyPage";
import SurveyDetailPage from "../../../features/survey/pages/SurveyDetailPage";
import SurveyPage from "../../../features/survey/pages/SurveyPage";
import SurveyResponsesPage from "../../../features/survey/pages/SurveyResponsesPage";
import { CreateUserPage, UpdateUserPage, UserListPage } from "../../../features/users/pages";
import {
  MerchantDetailsPage,
  MerchantListPage,
  MerchantUpdatePage,
} from "../../../features/merchant-management/pages";

export const adminRoutes = (
  <>
    <Route
      path="dashboard"
      element={<DashboardPage />}
    />
    <Route
      path="heat-map"
      element={<HeatMapPage />}
    />
    <Route
      path="reports"
      element={<ReportsPresentationSample />}
    />
    <Route
      path="reports/residents"
      element={<ResidentReportPage />}
    />
    <Route
      path="reports/nri-impact"
      element={<NriImpactReportPage />}
    />
    <Route
      path="reports/program-performance"
      element={<ProgramPerformanceReportPage />}
    />
    <Route
      path="reports/equity-reach"
      element={<NeighborhoodReachReportPage />}
    />
    <Route
      path="heatmap-pdf"
      element={<HeatMapPdfReport />}
    />
    <Route
      path="merchant-heatmap-pdf"
      element={<MerchantHeatmapPdfReport />}
    />
    <Route
      path="event"
      element={<EventListPage />}
    />
    <Route
      path="event/create"
      element={<EventCreatePage />}
    />
    <Route
      path="event/edit/:id"
      element={<EventUpdatePage />}
    />
    <Route
      path="event/view/:id"
      element={<EventDetailsPage />}
    />
    <Route
      path="event/update/:id"
      element={<EventUpdatePage />}
    />
    <Route
      path="event/create"
      element={<EventCreatePage />}
    />
    <Route
      path="survey"
      element={<SurveyPage />}
    />
    <Route
      path="surveys/create"
      element={<CreateSurveyPage />}
    />
    <Route
      path="survey/:id"
      element={<SurveyDetailPage />}
    />
    <Route
      path="survey/:id/responses"
      element={<SurveyResponsesPage />}
    />
    <Route
      path="survey/:id/edit"
      element={<EditSurveyPage />}
    />
    <Route
      path="notification"
      element={<NotificationPage />}
    />
    <Route
      path="notification/create"
      element={<CreateNotificationPage />}
    />
    <Route
      path="notification/:id"
      element={<EditNotificationPage />}
    />
    <Route
      path="news"
      element={<NewListPage />}
    />
    <Route
      path="news/create"
      element={<CreateNewsPage />}
    />
    <Route
      path="news/view/:id"
      element={<ViewNewsArticlePage />}
    />
    <Route
      path="news/update/:id"
      element={<UpdateNewsPage />}
    />
    <Route
      path="users"
      element={<UserListPage />}
    />
    <Route
      path="users/create"
      element={<CreateUserPage />}
    />
    <Route
      path="users/update/:id"
      element={<UpdateUserPage />}
    />
    <Route
      path="merchant-management"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <MerchantListPage />
        </RouteGuard>
      }
    />
    <Route
      path="merchant-management/view/:id"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <MerchantDetailsPage />
        </RouteGuard>
      }
    />
    <Route
      path="merchant-management/update/:id"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <MerchantUpdatePage />
        </RouteGuard>
      }
    />
    <Route
      path="recent-activity"
      element={<RecentActivityPage />}
    />
    <Route
      path="attendance"
      element={<AttendancePage />}
    />
    <Route
      path="e-gift-card"
      element={<EGiftCardPage />}
    />
    <Route
      path="merchant-brands"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <Navigate
            to="/catalog/merchant-brands"
            replace
          />
        </RouteGuard>
      }
    />
    <Route
      path="catalog/categories"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <CategoriesPage />
        </RouteGuard>
      }
    />
    <Route
      path="catalog/merchant-categories"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <MerchantCategoriesPage />
        </RouteGuard>
      }
    />
    <Route
      path="catalog/merchant-brands"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <MerchantBrandCatalogPage />
        </RouteGuard>
      }
    />
    <Route
      path="organizations"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <OrganizationsPage />
        </RouteGuard>
      }
    />
    <Route
      path="e-gift-card/create"
      element={<CreateEGiftCardPage />}
    />
    <Route
      path="e-gift-card/:id/edit"
      element={<UpdateEGiftCardPage />}
    />
    <Route
      path="rewards/create-brand-gift-card"
      element={<CreateEGiftCardPage />}
    />
    <Route
      path="rewards/edit-brand-gift-card/:id"
      element={<UpdateEGiftCardPage />}
    />
    <Route
      path="campaign"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <CampaignPage />
        </RouteGuard>
      }
    />
    <Route
      path="campaign/create"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <CreateCampaignPage />
        </RouteGuard>
      }
    />
    <Route
      path="campaign/:id/edit"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <UpdateCampaignPage />
        </RouteGuard>
      }
    />
    <Route
      path="campaign/:campaignId/program/edit"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <UpdateProgramPage />
        </RouteGuard>
      }
    />
    <Route
      path="reward-history"
      element={<RewardHistoryPage />}
    />
    <Route
      path="wallet-transaction"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <WalletTransactionsPage />
        </RouteGuard>
      }
    />
    <Route
      path="sync-points"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <SyncPointsPage />
        </RouteGuard>
      }
    />
    <Route
      path="outbox-notifications"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <OutboxNotificationsPage />
        </RouteGuard>
      }
    />
    <Route
      path="missing-rewards"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <MissingRewardsPage />
        </RouteGuard>
      }
    />
    <Route
      path="runtime-configuration"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <RuntimeConfigurationPage />
        </RouteGuard>
      }
    />
    <Route
      path="profile"
      element={<ProfilePage />}
    />
    <Route
      path="qr-scanner-tutorial"
      element={<QRScannerTutorial />}
    />
    <Route
      path="dev-playground"
      element={
        <RouteGuard allowedRoles={["super_admin"]}>
          <DevPlaygroundPage />
        </RouteGuard>
      }
    />
    <Route
      path="business-profile"
      element={<BusinessProfilePage />}
    />
    <Route
      path="merchant-profile"
      element={<ProfilePage />}
    />
    <Route
      path="merchant-coupon"
      element={<MerchantCouponListPage />}
    />
    <Route
      path="merchant-heatmap"
      element={<MerchantHeatmapPage />}
    />
  </>
);
